import function_with_timeout from '../../../lib/function_with_timeout';

class Base {
	constructor(data) {
		this.data = data;
	}

	set(original_data, data) {
		for (const key in original_data) {
			const value = original_data[key];
			if (value[0] == '!') {
				original_data[key] = data[value.slice(1)];
			}
		}
	}

	send(body, callback) {
		try {
			body();
		} catch(error) {
			callback();
		}
	}

	_function_with_timeout(...args) {
		return function_with_timeout(...args);
	}
}

export { Base };
